import { useDispatch } from 'react-redux';
import React, { useState } from 'react';
import { RxCross2 } from 'react-icons/rx';

import { CustomLoader } from '../../../services/Reducer';
import apiClient from '../../../api/apiClient';
import authServices from '../../../services/AuthServices';



const Add_table = ({ show, toggle, refreshData, AddcurrentPage }) => {
  const [formData, setFormData] = useState({

    service: '',
    message: '',
    templateId: '',
    senderId: '',
    userId: '',
    apiKey: '',
    EntityId: '',

  });
  const [errors, setErrors] = useState({}); // Error state
  const dispatch = useDispatch();

  const loader = (display) => {
    dispatch(CustomLoader(display));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    // Clear the error for the field being edited
    setErrors({ ...errors, [name]: '' });
  };

  const validateForm = () => {
    let formErrors = {};

    if (formData.service === '') {
      formErrors.service = 'Service cannot be empty';
    }

    if (formData.message === '') {
      formErrors.message = 'Message cannot be empty';
    }

    if (formData.templateId === '') {
      formErrors.templateId = 'Template ID cannot be empty';
    }

    if (formData.senderId === '') {
      formErrors.senderId = 'Sender ID cannot be empty';
    }

    if (formData.userId === '') {
      formErrors.userId = 'User ID cannot be empty';
    }

    if (formData.apiKey === '') {
      formErrors.apiKey = 'API apiKey cannot be empty';
    }

    if (formData.EntityId === '') {
      formErrors.entityId = 'Entity ID cannot be empty';
    }

    // Aap yahan formErrors ko return ya handle kar sakte hain


    setErrors(formErrors);
    return Object.Keys(formErrors).length === 0; // No errors
  };

  const token = authServices.getToken();
  const handleSubmit = async (e) => {
    // e.preventDefault();
    if (!validateForm()) {
      return; // Stop submission if there are validation errors
    }

    loader('enable');

    try {

      const response = await apiClient.post('/api/admin/sms_formate/add', formData, {
      
              headers: {
                'access_token': token,
              },
      
            });
      if (response.data.Status === "SUCCESS") {
        
      setFormData({
        feeType: '',

      });
    }
    else{
      console.log(response.data.message)
    }
    }
    catch (error) {
      console.error('catch Error :- ', error.response ? error.response.data.message : error);
    }
    finally {
      refreshData(AddcurrentPage);
      loader('disable');
      toggle(); // Close the modal after submission
      // window.location.reload();
    }
  };
  return (
    <>
      {show && (
        <>
          <div className="modal fade show d-block" id="exampleModalScrollable" tabIndex={-1} role="dialog" aria-labelledby="exampleModalScrollableTitle" aria-hidden="true">
            <div className="modal-dialog modal-dialog-scrollable">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalScrollableTitle">Add SMS_Formate</h5>
                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={toggle} >< RxCross2 /></button>
                </div>
                <div className="modal-body-custom">
                  <form >

                    <div className='row w-100'>
                    <div className="spacing w-50 d-inline-block" >
                      <label htmlFor="service" className="label-custom">Service</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.service ? 'input-error' : ''}`}
                        id="service"
                        name="service"
                        value={formData.service}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing w-50 d-inline-block" >
                      <label htmlFor="message" className="label-custom">Message</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.message ? 'input-error' : ''}`}
                        id="message"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                      />
                    </div>
                    </div>

                    <div className='row w-100'>
                    <div className="spacing w-50 d-inline-block">
                      <label htmlFor="templateId" className="label-custom">Template ID</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.templateId ? 'input-error' : ''}`}
                        id="templateId"
                        name="templateId"
                        value={formData.templateId}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing w-50 d-inline-block">
                      <label htmlFor="senderId" className="label-custom">Sender ID</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.senderId ? 'input-error' : ''}`}
                        id="senderId"
                        name="senderId"
                        value={formData.senderId}
                        onChange={handleChange}
                      />
                    </div>
                    </div>

                    <div className='row w-100'>
                    <div className="spacing w-50 d-inline-block">
                      <label htmlFor="userId" className="label-custom">User ID</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.userId ? 'input-error' : ''}`}
                        id="userId"
                        name="userId"
                        value={formData.userId}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing w-50 d-inline-block">
                      <label htmlFor="apiKey" className="label-custom">Api Key</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.apiKey ? 'input-error' : ''}`}
                        id="apiKey"
                        name="apiKey"
                        value={formData.apiKey}
                        onChange={handleChange}
                      />
                    </div>
                    </div>
                    
                    <div className="spacing" style={{width:'96.50%'}}>
                      <label htmlFor="EntityId" className="label-custom">Entity ID</label>
                      <input
                        type="text"
                        className={`input-custom ${errors.EntityId ? 'input-error' : ''}`}
                        id="EntityId"
                        name="EntityId"
                        value={formData.EntityId}
                        onChange={handleChange}
                      />
                    </div>



                  </form>
                </div>

                <div className="modal-footer">

                <button type="button" style={{ backgroundColor: '#F0F0F0', color: '#000', fontWeight: '500', border: "1px solid #d7dde2" }} className="btn " data-bs-dismiss="modal" onClick={toggle}>
                    Close
                  </button>
                  <button type="button" style={{ color: 'white', fontWeight: '500' }} className="btn btn-primary" onClick={handleSubmit}>
                    Submit
                  </button>

                </div>
              </div>
              {/* /.modal-content */}
            </div>
            {/* /.modal-dialog */}
          </div>
          {/* /.modal */}
        </>
      )}
    </>
  );
};

export default Add_table;
